module.exports = __webpack_public_path__ + "assets/img/girl@3x.b5ab17c0.png";